import React from 'react';
import { withStyles } from "@mui/styles";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';


import en from "../../i18n/English/Policies/Bsda.json";
import hi from "../../i18n/Hindi/Policies/Bsda.json";
import kn from "../../i18n/Kannada/Policies/Bsda.json";
import ma from "../../i18n/Marathi/Policies/Bsda.json";
import gu from "../../i18n/Gujarati/Policies/Bsda.json";
import { useLanguage } from "../../Context/LangContext";

const styles = theme => ({
    heading: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter500 !important',
        fontSize: 'calc(24px + var(--font-delta)) !important',
        marginBlockStart: 0,
        marginBlockEnd: 0,
        fontWeight: 'normal',
        "@media only screen and (max-device-width: 480px)": {
            color: '#FFFFFF !important',
            fontFamily: 'Inter500 !important',
            fontSize: 'calc(20px + var(--font-delta)) !important',
        }
    },
    p_body: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter400 !important',
        fontSize: 'calc(16px + var(--font-delta)) !important',
        lineHeight: "22px !important",
        "@media only screen and (max-device-width: 480px)": {

            fontFamily: 'Inter400 !important',
            fontSize: 'calc(14px + var(--font-delta)) !important',
            lineHeight: "20px !important",
        }
    },
    tableHeadCell: {
        borderRight: "1px solid white",
        background: "#130D2B",
        color: "#ffffff !important",
        fontSize:"calc(14px + var(--font-delta)) !important",
        width: "50%",
        "@media only screen and (max-device-width: 480px)": {}
    },
    tableBodyCell: {
        borderRight: "1px solid black",
        fontSize: "calc(12px + var(--font-delta)) !important",
        "@media only screen and (max-device-width: 480px)": {
            borderRight: "1px solid white !important",

        }
    }
})

const Bsda = ({ classes }) => {
    const { language } = useLanguage();
              const translations = { en, hi, kn ,ma, gu };
              const t = translations[language];
    return (
        <div style={{ height: 'auto', padding: '0px 0px 20px 0px' }}>
            <Grid style={{ padding: '20px 0px 40px 0px' }}>

                <h1 className={classes.heading} style={{ textAlign: 'center' }}>
                   {t.mainheading}
                </h1>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.title}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }}>
                    {t.introduction}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }}>
                    {t.introduction1}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }}>
                    {t.text}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%"
                    ,whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }}>
                    <b>{t.benefits[0].title}</b> : {t.benefits[0].text}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    <b>{t.benefits[1].title}</b> : {t.benefits[1].text}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    <b>{t.benefits[2].title}</b> : {t.benefits[2].text}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    <b>{t.benefits[3].title} </b>: {t.benefits[3].text}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                   }}>
                    <b>{t.benefits[3].title} </b>: {t.benefits[3].text}.
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                   }}>
                    <b>{t.benefits[4].title} </b>: {t.benefits[4].text}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                     }}>
                    <b>{t.benefits[5].title} </b>: {t.benefits[5].text}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                     }}>
                    {t.eligibility[0]}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                     }}>
                    <b>1.</b>  {t.eligibility[1]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    <b>2.</b> {t.eligibility[2]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                      }}>
                    <b>3.</b> {t.eligibility[3]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }}>
                    <b>4.</b> {t.eligibility[5]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                   }}>
                    <b>5.</b> {t.eligibility[6]}
                </Typography>


                    <h1 className={classes.heading} style={{
                        padding: '20px 0px 0px 0px', whiteSpace: "normal",
                        textAlign: "justify",
                        lineHeight: "1.5"
                      }}>
                    {t.charges.text}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                 }}>
                    {t.charges.text1}
                </Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }}>
                    <b>{t.charges.text2}</b>
                </Typography>

                <TableContainer>
                    <Table sx={{
                        width: 500,
                        border: "1px solid black",
                        margin: "20px 0px 0px 0px",
                        "@media screen and (max-width : 480px)": {
                            border: "1px solid white"
                        }
                    }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.tableHeadCell} align="center" >{t.charges.text3}</TableCell>
                                <TableCell sx={{ background: "#130D2B", color: "#ffffff", fontSize:"calc(14px + var(--font-delta))" }} align="center">{t.charges.text4}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell className={classes.tableBodyCell} align="center">{t.charges.amc[0].holding}</TableCell>
                                <TableCell className={classes.tableBodyCell} align="center">₹0</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.tableBodyCell} align="center">{t.charges.amc[1].holding}</TableCell>
                                <TableCell className={classes.tableBodyCell} align="center">{t.charges.amc[1].charges}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.tableBodyCell} sx={{
                                    borderBottom: "1px solid black",
                                    "@media only screen and (max-device-width: 480px)": {
                                        borderBottom: "1px solid white !important",
                                    }
                                }} align="center">{t.charges.amc[2].holding}</TableCell>
                                <TableCell className={classes.tableBodyCell} align="center" sx={{
                                    borderBottom: "1px solid black",
                                    "@media only screen and (max-device-width: 480px)": {
                                        borderBottom: "1px solid white !important",
                                    }
                                }}>{t.charges.amc[2].charges}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <Typography className={classes.p_body} style={{ padding: '20px 0px 0px 0px' }}>
                    <b>{t.charges.subtitle}</b>
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                 }}>
                    {t.charges.statements}
                </Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }}>
                    <b>{t.charges.subtitle1}</b>
                </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }}>
                    {t.charges.additional_charges}
                </Typography>

                {/* Rest of the content remains exactly the same */}
                {/* ... */}


                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.conversionTitle}
                    </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }} >
                    {t.conversion1}
                    </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }} >
                    {t.conversion2}
                    </Typography>


                    <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.sebi.title}
                    </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5" }} >
                    {t.sebi.text}
                    </Typography>

                    <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                    <b>{t.sebi.points[0].title}</b>
                    </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                   }} >
                        • {t.sebi.points[0].points[0]}<br/>
                        • {t.sebi.points[0].points[1]}<br/>
                        • {t.sebi.points[0].points[2]}
                    </Typography>

                    <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                        <b>{t.sebi.points[1].title}</b>
                    </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
}} >
                        • {t.sebi.points[1].points[0]}<br/>
                        • {t.sebi.points[1].points[1]}<br/>
                        • {t.sebi.points[1].points[2]}
                    </Typography>

                    <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                       <b>{t.sebi.points[2].title}</b>
                    </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                  }} >
                    • {t.sebi.points[2].points[0]}<br/>
                    • {t.sebi.points[2].points[1]}
                    </Typography>


                    <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                    <b>{t.sebi.points[3].title}</b>
                    </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }} >
                    {t.sebi.points[3].points[0]}
                    </Typography>

                    <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} >
                     <b>{t.sebi.points[4].title}</b>
                    </Typography>
                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                   }} >
                    {t.sebi.points[4].points[0]}
                    </Typography>

                    <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.sebi.points[5].steptitle}
                    </h1>
                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >{t.sebi.points[5].text}:</Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} ><b>{t.sebi.points[5].step[0].title}</b></Typography>

                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >{t.sebi.points[5].step[0].text}</Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} ><b>{t.sebi.points[5].step[1].title}</b></Typography>
                    <Typography className={classes.p_body} style={{ padding: '5px 0px 0px 0px' }} >
                    • {t.sebi.points[5].step[1].points[0]}<br/>
                    • {t.sebi.points[5].step[1].points[1]}<br/>
                    • {t.sebi.points[5].step[1].points[2]}</Typography>
                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} ><b>{t.sebi.points[5].step[2].title}</b></Typography>
                <Typography className={classes.p_body} style={{ padding: '5px 0px 0px 0px' }} >• {t.sebi.points[5].step[2].points[0]}<br/>
                    • {t.sebi.points[5].step[2].points[1]}</Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} ><b>{t.sebi.points[5].step[3].title}</b></Typography>
                    <Typography className={classes.p_body} style={{ padding: '5px 0px 0px 0px' }} >
                        • {t.sebi.points[5].step[3].points[0]}<br/>
                        • {t.sebi.points[5].step[3].points[1]}<br/>
                        • {t.sebi.points[5].step[3].points[2]}<br/>
                        • {t.sebi.points[5].step[3].points[3]}</Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} ><b>{t.sebi.points[5].step[4].title}:</b></Typography>
                <Typography className={classes.p_body} style={{
                    padding: '5px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >{t.sebi.points[5].step[4].text}</Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} ><b>{t.sebi.points[5].step[5].title}</b></Typography>
                <Typography className={classes.p_body} style={{ padding: '5px 0px 0px 0px' }} > {t.sebi.points[5].step[5].text}</Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} ><b>{t.sebi.points[5].step[6].title}</b></Typography>
                <Typography className={classes.p_body} style={{ padding: '5px 0px 0px 0px' }} >{t.sebi.points[5].step[6].text}</Typography>

                <Typography className={classes.p_body} style={{ padding: '10px 0px 0px 0px' }} ><b>{t.sebi.points[5].step[7].title}</b></Typography>
                <Typography className={classes.p_body} style={{ padding: '5px 0px 0px 0px' }} >{t.sebi.points[5].step[7].text}</Typography>

                    <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }} >
                    {t.sebi.points[5].step[8].title}
                    </h1>
                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >{t.sebi.points[5].step[8].text}</Typography>

                <Typography className={classes.p_body} style={{
                    padding: '10px 0px 0px 0px', maxWidth: "100%",
                    whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }} >{t.sebi.points[5].step[8].text1}</Typography>

            </Grid>
        </div>
    );
}

export default withStyles(styles)(Bsda);